import { AxiosError } from "axios";

import api from "services/api";
import { returnResponse } from "services/utils";

export interface IHearingFileType {
  id: number;
  name: string;
  active: boolean;
  customerId: number;
}

export const HearingFileTypeService = {
  getAll: async (customerId: number, status?: 0 | 1 | null) => {
    try {
      const { data } = await api.get<any>(
        `/v1/HearingFileType/GetAllByCustomerId?customerId=${customerId}${
          status === 0 || status === 1 ? `&active=${status}` : ""
        }`,
      );

      return {
        status: true,
        data: data,
        message: data.message,
      };
    } catch (error) {
      if (error instanceof AxiosError) {
        const messages = error?.response?.data?.errors;
        const { severity, status, message, data } = returnResponse({
          statusCode: error.response?.status,
          data: error?.response?.data,
          message: Array.isArray(messages)
            ? messages.at(0)?.message
            : "An unexpected error occurred",
        });

        return {
          severity,
          status,
          message: message ? message : "Error",
          data,
        };
      }

      return {
        status: false,
        message: "Error",
        data: null,
        severity: "error",
      };
    }
  },
};
